module.exports = __webpack_public_path__ + "img/beer-mug-empty.00072e1e.svg";